exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay-actions__actions__1M7Xe{position:absolute;top:12px;right:12px;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex-direction:column;flex-direction:column}.overlay-actions__actions__1M7Xe.overlay-actions__at-full-screen__206-a{top:24px;right:24px}.overlay-actions__action-button__du-2A{margin-bottom:12px}.overlay-actions__at-full-screen__206-a .overlay-actions__action-button__du-2A{margin-bottom:18px}@media (max-width:639px){.overlay-actions__action-button__du-2A{margin-bottom:10px}}", ""]);

// exports
exports.locals = {
	"actions": "overlay-actions__actions__1M7Xe",
	"at-full-screen": "overlay-actions__at-full-screen__206-a",
	"atFullScreen": "overlay-actions__at-full-screen__206-a",
	"action-button": "overlay-actions__action-button__du-2A",
	"actionButton": "overlay-actions__action-button__du-2A"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/overlay-actions/overlay-actions.styl
// module id = 1312
// module chunks = 0 1 2 3